var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fieldset", { staticClass: "rating-input" }, [
    _vm.legend
      ? _c("legend", { domProps: { innerHTML: _vm._s(_vm.legend) } })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "rating-input__wrapper",
        on: { mouseenter: _vm.onMouseEnter, mouseleave: _vm.onMouseLeave }
      },
      _vm._l(_vm.max, function(i) {
        return _c(
          "label",
          {
            key: "rating-input-" + i,
            staticClass: "rating-input__label",
            on: {
              mouseover: function($event) {
                return _vm.onHover(i)
              }
            }
          },
          [
            _c("input", {
              staticClass: "rating-input__input",
              attrs: {
                type: "radio",
                id: _vm.uniqueId + "-" + i,
                name: _vm.name,
                required: _vm.required,
                disabled: _vm.disabled
              },
              domProps: { value: i, checked: i === _vm.value },
              on: {
                change: function($event) {
                  return _vm.onChange(i)
                }
              }
            }),
            _vm._v(" "),
            _c("SVGStarFilled", {
              staticClass: "rating-input__icon",
              class: {
                "rating-input__icon--active": _vm.mouseOver
                  ? _vm.hover >= i
                  : _vm.value >= i
              }
            })
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }